export default __webpack_public_path__ + "static/media/DinosaursFossilHunters_06.474a53e3.png";